import { STATIC_FILES_URL } from 'env/server';

export const convertToValidUrl = (url) => STATIC_FILES_URL + url;
